import ActiveRecord from './ActiveRecord';
import NetworkLayer from '../utils/networkLayer';

class Blog extends ActiveRecord {
  constructor() {
    super();
  }

  getBlogs(url, params) {
    const request = { params };
    return NetworkLayer.getJson(url, request)
      .then(response => response)
      .catch(e => e);
  }

  getBlogById(url, { id }) {
    return NetworkLayer.getJson(`${url}/${id}`)
      .then(response => response)
      .catch(e => e);
  }

  getBlogBySlug(url, { slug }) {
    return NetworkLayer.getJson(`${url}/${slug}`)
      .then(response => response)
      .catch(e => e);
  }

  createBlog(url, data) {
    const request = { data };
    return NetworkLayer.postJson(url, request)
      .then(response => response)
      .catch(e => e);
  }

  updateBlog(url, data) {
    const { id, ...blogData } = data;
    const request = { data: blogData };
    return NetworkLayer.putJson(`${url}/${id}`, request)
      .then(response => response)
      .catch(e => e);
  }

  deleteBlog(url, { id }) {
    return NetworkLayer.deleteJson(`${url}/${id}`)
      .then(response => response)
      .catch(e => e);
  }

  searchBlogs(url, params) {
    const request = { params };
    return NetworkLayer.getJson(url, request)
      .then(response => response)
      .catch(e => e);
  }

  publishBlog(url, { id }) {
    return NetworkLayer.postJson(`${url}/${id}/publish`)
      .then(response => response)
      .catch(e => e);
  }

  uploadImage(url, requestConfig) {
    const file = requestConfig && requestConfig.file ? requestConfig.file : requestConfig;
    
    const allowedMimeTypes = ['image/jpeg', 'image/png'];
    const allowedExtensions = ['.jpg', '.jpeg', '.png'];
    const maxFileSize = 5 * 1024 * 1024;

    if (!(file instanceof File)) {
      return Promise.reject(new Error('Invalid file input.'));
    }

    const fileName = file.name.toLowerCase();
    const dotIndex = fileName.lastIndexOf('.');
    const fileExtension = dotIndex >= 0 ? fileName.substring(dotIndex) : '';

    if (!allowedMimeTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
      return Promise.reject(new Error('Unsupported file type. Only JPEG and PNG images are allowed.'));
    }

    if(file.size > maxFileSize) {
      return Promise.reject(new Error('Image is too large. Max size is 5MB.'));
    }

    return NetworkLayer.postFormData(url, {
      data: { file }
    })
      .then(response => response)
      .catch(e => e);
  }
}

export default Blog;

